<template>
    <section class="order-section">
        <hr>

        <order-item title="Subtotaal" :price="subTotal"/>
        <order-item title="Verzending" :price="deliveryPrice" :is-free="deliveryPrice === 0"/>
        <order-item :title="`BTW ${btwValue}%`" :price="btw"/>

        <hr>

        <div class="d-flex flex-row justify-content-between">
            <span class="title">Totaalprijs</span>
            <span class="price blue" v-text="price(total)"></span>
        </div>
        <span class="sub-title btw">{{ price(total + btw) }} incl.btw</span>

        <router-link :to="{ name: 'powerpack-configurator' }" tag="button" @click.native="$emit('animate')">
            <img src="../../../assets/cart-icon.png">
            <span>In systeem</span>
        </router-link>
    </section>
</template>

<script>
  import OrderItem from "./items/OrderItem";
  import orderMixin from "../../../mixins/orderMixin";
  import {mapGetters, mapState} from "vuex";
  import getBuildMixin from "../../../mixins/getBuildMixin";

  export default {
    name: "OrderTotal",

    components: {
      OrderItem,
    },

    mixins: [orderMixin, getBuildMixin],

    computed: {
      ...mapState({
        btwValue: state => state.preference.BTW | 0
      }),

      subTotal() {
        let price = 0;

        price += this.motor ? this.motor.price : 0;
        price += this.pump ? this.pump.price : 0;
        price += this.tank ? this.tank.price : 0;
        price += this.circuit ? this.circuit.price : 0;

        // Valves
        if (this.valves && this.valves.length) {
          for (const v of this.valves) {
            //todo valves doesn't have a price yet
            // price += v.price;

            for (const av of v.additionalValves) {
              //todo addvalves doesn't have a price yet
              // price += av.price;
            }
          }
        }
        // Additional options
        if (this.options) {
          for (const option of this.options) {
            price += option.price || 0;
          }
        }

        return price;
      },

      deliveryPrice() {
        // @todo ?
        return 0;
      },

      btw() {
        return this.subTotal * (this.btwValue / 100);
      },

      total() {
        return this.subTotal + this.deliveryPrice;
      }
    },

    methods: {
      price(val) {
        return (val / 100).toFixed(2);
      },
    }
  }
</script>
